import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var AppInfoParser = require("app-info-parser/src/apk");
export default {
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      // 表单
      form: {
        downloadUrl: "",
        // 安装包链接
        version: "",
        // 版本
        isMust: false,
        type: 2,
        // 1 旧版 2 国际版
        latestVersion: ""
      },
      dialogVisible: false,
      // 弹窗状态

      dialogIosVisible: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    // 更新IOS版本弹窗
    iosDialog: function iosDialog() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.dialogIosVisible = true;
              _context2.n = 1;
              return _this2.$api.getVersionInfo({
                id: "15390517451331325"
              });
            case 1:
              res = _context2.v;
              console.log(res);
              _this2.form.version = res.data.version;
              _this2.form.latestVersion = res.data.latestVersion || "";
              _this2.form.isMust = res.data.isMust;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // 更新IOS版本
    saveIos: function saveIos() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.updateVersion({
                id: "15390517451331325",
                version: _this3.form.version,
                latestVersion: _this3.form.latestVersion,
                isMust: _this3.form.isMust,
                type: 100 // ios
              });
            case 1:
              res = _context3.v;
              _this3.$message.success("修改成功");
              _this3.dialogIosVisible = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getVersionList(_this4.searchForm);
            case 1:
              res = _context4.v;
              _this4.tableData = res.data.list;
              _this4.total = res.data.count;
              _this4.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    addDialog: function addDialog() {
      this.dialogVisible = true;
      this.form = {
        downloadUrl: "",
        // 安装包链接
        version: "",
        // 版本
        isMust: false,
        type: 2 // 1 旧版 2 国际版
      };
    },
    fileSelect: function fileSelect(e) {
      var _this5 = this;
      var file = e.currentTarget.files[0];
      var parser = new AppInfoParser(file);
      parser.parse().then(function (result) {
        _this5.form.version = result.versionCode;
      }).catch(function (err) {
        console.log("err ----> ", err);
      });
    },
    save: function save() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              res = null;
              if (!_this6.form.id) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return _this6.$api.updateVersion(_this6.form);
            case 1:
              res = _context5.v;
              _context5.n = 4;
              break;
            case 2:
              _context5.n = 3;
              return _this6.$api.addVersion(_this6.form);
            case 3:
              res = _context5.v;
            case 4:
              _this6.dialogVisible = false;
              _this6.form = {};
              _this6.getData();
            case 5:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};